
// モジュールを読込.
import { Options, Prop, Vue, Watch, Ref } from "vue-property-decorator"
import Util from "packs/utils/Util"
import isMobile from "ismobilejs"
import { gtagClick, gtagPage } from "packs/GoogleTagManager"
import { funcName, Logger } from "packs/common"

// コンポーネントを読込.
import AddCommentToMail from "packs/pages/link/parts/room_settings/AddCommentToMail.vue"
import Switcher from "packs/components/forms/Switcher.vue"
import MdTextfieldTag from "packs/components/forms/MdTextfieldTag.vue"
import SelectTag from "packs/components/forms/SelectTag.vue"
import IconHelp from "packs/components/icons/IconHelp.vue"
import SpanSlotContent from "packs/components/common/SpanSlotContent.vue"
import CustomMailFlowList from "packs/pages/link/parts/room_settings/mail_parts/CustomMailFlowList.vue"
import CheckboxTag from "packs/components/forms/CheckboxTag.vue"
import LblueListContent from "packs/components/calendar/LblueListContent.vue"
import VariableListsContent from "packs/pages/link/parts/room_settings/VariableListsContent.vue"

// モデルを読込.
import RoomManager from "packs/models/RoomManager"
import RoomMember from "packs/models/RoomMember"
import Appointment from "packs/models/Appointment"
import MessageTemplate from "packs/models/MessageTemplate"
import TemplateUtil from "packs/utils/TemplateUtil"
import RoomStorage from "packs/models/RoomStorage"
import RoomCreateManager from "packs/models/RoomCreateManager"
import Room from "packs/models/Room"
import Notice from "packs/models/Notice"
import MailFlow from "packs/models/MailFlow"
import SelectUtil from "packs/utils/SelectUtil"
import axios from "types/axios"
import NotificationControl from "packs/utils/NotificationControl"
import AutoCreateRoomRule from "packs/models/AutoCreateRoomRule"
import GroupTag from "packs/models/GroupTag"

const roomStorage = new RoomStorage()

@Options({
    components: {
        AddCommentToMail,
        Switcher,
        MdTextfieldTag,
        SelectTag,
        IconHelp,
        SpanSlotContent,
        CustomMailFlowList,
        CheckboxTag,
        LblueListContent,
        VariableListsContent,
    },
})
export default class AutoCreateRoomRuleEditDetailContent extends Vue {
    // data:

    @Prop()
    tmp: MessageTemplate // templateのpublic_id

    rm = RoomManager
    rcm = RoomCreateManager
    isSP = isMobile(window.navigator).phone

    // 今回利用するテンプレ.
    localTmp: MessageTemplate = null
    memo = ``
    selectedTabName = this.rcm.room && this.rcm.room.room_type == `parent_room` ? `create_room` : `inquire_on_public_room`

    // テンプレ更新ボタンの表示
    showUpdateTmpButton = false

    currentAppo: Appointment = null

    parentTimingArray = Util.timingsDicArray(`parent_room`)
    publicTimingArray = Util.timingsDicArray(`public_room`)
    sendTimingArray = null
    showSwitchers = false

    SelectUtil = SelectUtil

    // 設定したカスタム通知内容
    customMailFlows = []

    // 紐付ける公開ページの公開ID
    publicId = null

    loading = false
    selectedRoom: Room = null
    selectedTags: GroupTag[] = []
    availableTags: GroupTag[] = []

    openTitleVariables = false
    openOwnerTitleVariables = false
    openGuestTitleVariables = false

    hideTitleButtons = false
    hideOwnerTitleButtons = false
    hideGuestTitleButtons = false

    mounted() {
        // this.currentAppo = roomStorage.fetchAppointment()

        this.setPublicRooms()
        this.setSelectedTags()
    }

    setSelectedTags() {
        let _rule = this.rcm.selectedRule
        this.selectedTags = _rule.group_tags

        this.rm.getGroupTags().then(tags => {
            if (tags) {
                this.availableTags = tags
            } else {
                this.availableTags = []
            }
        })
    }

    inputCopyPubRoomPublicId(e) {
        Logger(`${funcName()} e:${e}`)
        this.publicId = e
        let _rule = this.rcm.selectedRule
        _rule.copy_pub_room_public_id = e
        this.rcm.updateAutoCreateRoomRule(_rule)
    }

    inputCopyPubRoomTitle(e) {
        Logger(`${funcName()} e:${e}`)
        let _rule = this.rcm.selectedRule
        _rule.copy_pub_room_title = e
        this.rcm.updateAutoCreateRoomRule(_rule)
    }

    inputOwnerOpenScheduleTitle(e) {
        Logger(`${funcName()} e:${e}`)
        let _rule = this.rcm.selectedRule
        _rule.astag_owner_open_schedule_title = e
        this.rcm.updateAutoCreateRoomRule(_rule)
    }

    inputGuestOpenScheduleTitle(e) {
        Logger(`${funcName()} e:${e}`)
        let _rule = this.rcm.selectedRule
        _rule.guest_open_schedule_title = e
        this.rcm.updateAutoCreateRoomRule(_rule)
    }

    clickConnectPublicPage() {
        if (this.loading) return
        this.loading = true

        this.rm.startProgress()
        Room.search([this.publicId], this.rm.userInfo.user_id, null, null, null, null, null).then(rooms => {
            if (Util.isPresent(rooms)) {
                this.selectedRoom = rooms[0]
                this.publicId = this.selectedRoom.public_id
            } else {
                Notice.message = `公開ページが見つかりませんでした。`
            }
            this.rm.endProgress()
            this.loading = false
        })
    }

    @Watch("rm.userInfo")
    setPublicRooms() {
        if (!this.rm.userInfo) return

        let _rule = this.rcm.selectedRule
        if (Util.isBlank(_rule)) return

        let roomId = _rule.copy_pub_room_public_id
        if (Util.isBlank(roomId)) return

        if (this.selectedRoom && this.selectedRoom.id == roomId) return

        Room.search([roomId], this.rm.userInfo.user_id, null, null, null, null, null).then(rooms => {
            if (rooms.length > 0) {
                this.selectedRoom = rooms[0]
                this.publicId = rooms[0].public_id
            }
        })
    }

    public deselect() {
        Logger(`選択した公開ページFEEDBACKをはずします.`)

        let _rule = this.rcm.selectedRule
        this.selectedRoom = null
        this.publicId = null
        this.rcm.updateAutoCreateRoomRule(_rule)
    }

    get getDescription(): string {
        let _rule = this.rcm.selectedRule

        return ``
    }

    changeActiveRule(rule: AutoCreateRoomRule) {
        Logger(`${funcName()} rule:${Util.output(rule)}`)
        if (this.rcm.selectedRule) return

        let _rule = this.rcm.selectedRule
        if (_rule.is_active) {
            _rule.is_active = false
        } else {
            _rule.is_active = true
        }

        this.rcm.updateAutoCreateRoomRule(_rule)
    }

    saveRule() {
        Logger(`${funcName()}`)
        this.rcm.updateAutoCreateRoomRule(this.rcm.selectedRule)
        this.rcm.selectedRule = null
        this.selectedTags = []
    }

    selectTag(type: string, tag: GroupTag) {
        Logger(`${funcName()} type:${type} tag:${Util.output(tag)}`)
        if (type == `add`) {
            if (this.selectedTags.find(t => t.id == tag.id)) return
            this.selectedTags.push(tag)
        } else {
            this.selectedTags = this.selectedTags.filter(t => t.id != tag.id)
        }
    }

    selectTitleVariable(variable: string) {
        Logger(`${funcName()} variable:${variable}`)
        let _rule = this.rcm.selectedRule
        _rule.copy_pub_room_title = `${_rule.copy_pub_room_title || ``}${variable}`
        this.rcm.updateAutoCreateRoomRule(_rule)
    }

    selectOwnerTitleVariable(variable: string) {
        Logger(`${funcName()} variable:${variable}`)
        let _rule = this.rcm.selectedRule
        _rule.astag_owner_open_schedule_title = `${_rule.astag_owner_open_schedule_title || ``}${variable}`
        this.rcm.updateAutoCreateRoomRule(_rule)
    }

    selectGuestTitleVariable(variable: string) {
        Logger(`${funcName()} variable:${variable}`)
        let _rule = this.rcm.selectedRule
        _rule.guest_open_schedule_title = `${_rule.guest_open_schedule_title || ``}${variable}`
        this.rcm.updateAutoCreateRoomRule(_rule)
    }

    openValBox(type: string) {
        Logger(`${funcName()} type:${type}`)
        if (type == `title`) {
            if (this.openTitleVariables) {
                this.openTitleVariables = false
            } else {
                this.openTitleVariables = true
            }
        } else if (type == `owner_title`) {
            if (this.openOwnerTitleVariables) {
                this.openOwnerTitleVariables = false
            } else {
                this.openOwnerTitleVariables = true
            }
        } else if (type == `guest_title`) {
            if (this.openGuestTitleVariables) {
                this.openGuestTitleVariables = false
            } else {
                this.openGuestTitleVariables = true
            }
        }
    }

    changeSendMailToAstagOwner() {
        Logger(`${funcName()} `)
        let _rule = this.rcm.selectedRule
        if (_rule.is_send_astag_owner) {
            _rule.is_send_astag_owner = false
        } else {
            _rule.is_send_astag_owner = true
        }
        this.rcm.updateAutoCreateRoomRule(_rule)
    }
}
